import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { RegistrationIntro } from './pages/RegistrationIntro';
import { PhysicalRegistration } from './pages/PhysicalRegistration';
import { VirtualRegistration } from './pages/VirtualRegistration';
import { Podcast } from './pages/Podcast';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { PreEventSeries } from './pages/PreEventSeries';
import { Volunteer } from './pages/Volunteer';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/event" element={<RegistrationIntro data-id="element-5" />} data-id="element-4" />
        <Route path="/physical" element={<PhysicalRegistration data-id="element-7" />} data-id="element-6" />
        <Route path="/virtual" element={<VirtualRegistration data-id="element-9" />} data-id="element-8" />
        <Route path="/podcast" element={<Podcast data-id="element-11" />} data-id="element-10" />
        <Route path="/blog" element={<Blog data-id="element-13" />} data-id="element-12" />
        <Route path="/blog/:slug" element={<BlogPost data-id="element-15" />} data-id="element-14" />
        <Route path="/about" element={<About data-id="element-17" />} data-id="element-16" />
        <Route path="/contact" element={<Contact data-id="element-19" />} data-id="element-18" />
        <Route path="/pre-event-series" element={<PreEventSeries data-id="element-21" />} data-id="element-20" />
        <Route path="/volunteer" element={<Volunteer data-id="element-23" />} data-id="element-22" />
      </Routes>
    </BrowserRouter>;
}